import { render, staticRenderFns } from "./priceformat.vue?vue&type=template&id=b6d9ba84&"
import script from "./priceformat.vue?vue&type=script&lang=js&"
export * from "./priceformat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6d9ba84')) {
      api.createRecord('b6d9ba84', component.options)
    } else {
      api.reload('b6d9ba84', component.options)
    }
    module.hot.accept("./priceformat.vue?vue&type=template&id=b6d9ba84&", function () {
      api.rerender('b6d9ba84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2AJLJdN0bSk2L/JS/priceformat.vue"
export default component.exports